import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ListItem } from '../List';

// Types
import { IStore } from '../../store/Store';

// Component
export interface IProps {
    store?: IStore;

    routeName: string;
    routeParams?: object;
    routeOptions?: object;

    onClick?: React.MouseEventHandler<HTMLElement>;
}

function LinkButton({ store, routeName, routeParams = {}, routeOptions = {}, onClick, ...props }: IProps) {
    return (
        <ListItem
            {...props}
            button={true}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                if (onClick) {
                    onClick(e);
                }
                store!.routerStore.navigate(routeName, routeParams, routeOptions);
            }}
        />
    );
}

export default inject('store')(observer(LinkButton));


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/List/ListLinkItem.tsx